export default __webpack_public_path__ + "static/media/about-greeting-1.818d1508.png";